import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import CustomButton from 'shared/custom-button/CustomButton';
import { colors } from 'app/providers/theme/colors-type';
import styles from 'pages/mite-policy/MitePolicy.module.css';
import UgskLogo from 'shared/assets/UgskLogo';
import { useAppDispatch, useAppSelector } from 'shared/utils/hooks/useRedux';
import { Button } from '@mui/material';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { StepOne } from 'features/cancer-protection/step-1/StepOne';
import { StepTwo } from 'features/cancer-protection/step-2/StepTwo';
import { StepTree } from 'features/cancer-protection/step-3/StepTree';
import { updateField } from 'entities/cancer-protection/step-1';

const steps = ['Расчет', 'Оформление', 'Оплата'];

export const CancerProtection: React.FC = () => {
    const [activeStep, setActiveStep] = useState(0);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const location = useLocation();

    const AgentSalesDataID = location.state?.AgentSalesDataID;

    const [triggerPay, setTriggerPay] = useState(false);

    const handleNext = () => setActiveStep((prev) => prev + 1);
    const handleBack = () => setActiveStep((prev) => prev - 1);

    const [windowWidth, setWindowWidth] = React.useState<number>(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const stepperActiveStep = activeStep === 2 && triggerPay ? 3 : activeStep;

    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(updateField({ field: 'AgentSalesDataID', value: AgentSalesDataID }));
    }, [AgentSalesDataID]);

    return (
        <>
            <Box className={styles.titleContainer}>
                <UgskLogo />
            </Box>
            <Box className={styles.stepsTextContainer}>
                {steps.map((label, index) => (
                    <Typography
                        key={label}
                        className={`${styles.stepText} ${isMobile ? '' : styles.stepTextDesktop} ${activeStep === index ? styles.stepTextActive : ''}`}
                    >
                        {label}
                    </Typography>
                ))}
            </Box>

            <Box className={styles.stepperContainer}>
                <Stepper
                    activeStep={stepperActiveStep}
                    className={styles.stepper}
                    sx={{
                        '& .MuiStep-root': {
                            '& .MuiStepLabel-root': {
                                '& .Mui-active': {
                                    color: colors.primary,
                                },
                            },
                            '& .MuiStepIcon-root': {
                                '&.Mui-active': {
                                    color: colors.primary,
                                },
                                '&.Mui-completed': {
                                    color: colors.primary,
                                },
                            },
                        },
                    }}
                >
                    {steps.map((label) => (
                        <Step key={label} className={styles.stepperStep}>
                            <StepLabel className={styles.stepperLabel} />
                        </Step>
                    ))}
                </Stepper>
            </Box>
            {activeStep === steps.length ? (
                <Typography sx={{ mt: 2, mb: 1 }}>Все шаги завершены</Typography>
            ) : (
                <>
                    {activeStep === 0 && <StepOne windowWidth={windowWidth} handleNext={handleNext} />}
                    {activeStep === 1 && <StepTwo handleNext={handleNext} windowWidth={windowWidth} />}
                    {activeStep === 2 && <StepTree handleNext={handleNext} windowWidth={windowWidth} setTriggerPay={setTriggerPay} />}
                    <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2, alignItems: 'center' }}>
                        {activeStep > 0 && !triggerPay && (
                            <Button onClick={handleBack} className={styles.btnBack}>
                                <KeyboardBackspaceIcon /> Вернуться к шагу {steps[activeStep - 1]}
                            </Button>
                        )}
                        {activeStep !== 0 && activeStep !== 1 && activeStep !== 2 && (
                            <CustomButton
                                title="Продолжить"
                                handleClick={handleNext}
                                textColor="white"
                                backgroundColor={colors.primary}
                                width="150px"
                                gap="10px"
                                borderRadius='4px'
                                padding='3px'
                            />
                        )}


                    </Box>
                </>
            )}

        </>
    );
};
